import React, { Component } from "react";

import PropTypes from "prop-types";

import { Hidden } from "@material-ui/core";

import AboutDialog from "../AboutDialog";

import SignInDialog from "../Auth/SignInDialog";
import SettingsDialog from "../Profile/SettingsDialog";
import DeleteAccountDialog from "../Auth/DeleteAccountDialog";
import AlertDialog from "../AlertDialog";
import PostDialog from "../PostDialog/PostDialog";
import UserListDialog from "../Profile/Users/UserListDialog";
import ContributorDialog from "../Lighthouse/ContributorDialog";
import SubscriptionDialog from "../Lighthouse/SubscriptionDialog";
import ConfirmationDialog from "../Lighthouse/ConfirmationDialog";

class DialogHost extends Component {
  render() {
    // Properties
    const { performingAction, theme, user, userData, dialogs } = this.props;

    // Functions
    const { openSnackbar } = this.props;

    const aboutDialog = dialogs.aboutDialog;
    const confirmationDialog = dialogs.confirmationDialog;
    const signInDialog = dialogs.signInDialog;
    const settingsDialog = dialogs.settingsDialog;
    const deleteAccountDialog = dialogs.deleteAccountDialog;
    const signOutDialog = dialogs.signOutDialog;
    const newPostDialog = dialogs.newPostDialog;
    const userListDialog = dialogs.userListDialog;
    const contributorDialog = dialogs.contributorDialog;

    return (
      <>
        <ContributorDialog
          dialogProps={{
            ...contributorDialog.dialogProps,
          }}
        />
        <AboutDialog
          dialogProps={aboutDialog.dialogProps}
          performingAction={performingAction}
          theme={theme}
          user={user}
          userData={userData}
          openSnackbar={openSnackbar}
          {...aboutDialog.props}
        />


        <ConfirmationDialog
              dialogProps={{
                ...confirmationDialog.dialogProps,
              }}
              performingAction={performingAction}
              theme={theme}
              {...confirmationDialog.props}
            />  

        {user && (
          <>
            <AlertDialog
              dialogProps={signOutDialog.dialogProps}
              performingAction={performingAction}
              theme={theme}
              user={user}
              userData={userData}
              openSnackbar={openSnackbar}
              {...signOutDialog.props}
            />
          </>
        )}

        <Hidden xsDown>
          {user && (
            <>
            <SettingsDialog
                dialogProps={settingsDialog.dialogProps}
                performingAction={performingAction}
                theme={theme}
                user={user}
                userData={userData}
                openSnackbar={openSnackbar}
                {...settingsDialog.props}
              />
              <DeleteAccountDialog
                dialogProps={deleteAccountDialog.dialogProps}
                performingAction={performingAction}
                theme={theme}
                user={user}
                userData={userData}
                openSnackbar={openSnackbar}
                {...deleteAccountDialog.props}
              />

              <PostDialog
                dialogProps={{
                  ...newPostDialog.dialogProps,
                }}
                theme={theme}
              />

              <UserListDialog
                dialogProps={{
                  ...userListDialog.dialogProps,
                }}
                theme={theme}
              />

            </>
          )}

          {!user && (
            <>
              <SignInDialog
                dialogProps={signInDialog.dialogProps}
                performingAction={performingAction}
                theme={theme}
                user={user}
                userData={userData}
                openSnackbar={openSnackbar}
                {...signInDialog.props}
              />

            </>
          )}
        </Hidden>

        <Hidden smDown>
          {user && (
            <>

              <SettingsDialog
                dialogProps={settingsDialog.dialogProps}
                performingAction={performingAction}
                theme={theme}
                user={user}
                userData={userData}
                openSnackbar={openSnackbar}
                {...settingsDialog.props}
              />
            </>
          )}
        </Hidden>

        <Hidden smUp>
          {user && (
            <>
            <SettingsDialog
                dialogProps={{
                  fullScreen: true,
                  ...settingsDialog.dialogProps,
                }}
                performingAction={performingAction}
                theme={theme}
                user={user}
                userData={userData}
                openSnackbar={openSnackbar}
                {...settingsDialog.props}
              />
              <DeleteAccountDialog
                dialogProps={{
                  fullScreen: true,

                  ...deleteAccountDialog.dialogProps,
                }}
                performingAction={performingAction}
                theme={theme}
                user={user}
                userData={userData}
                openSnackbar={openSnackbar}
                {...deleteAccountDialog.props}
              />

              <PostDialog
                dialogProps={{
                  fullScreen: true,

                  ...newPostDialog.dialogProps,
                }}
                theme={theme}
              />

              <UserListDialog
                dialogProps={{
                  fullScreen: true,

                  ...userListDialog.dialogProps,
                }}
                theme={theme}
              />

            </>
          )}

          {!user && (
            <>
              <SignInDialog
                dialogProps={{
                  fullScreen: true,

                  ...signInDialog.dialogProps,
                }}
                performingAction={performingAction}
                theme={theme}
                user={user}
                userData={userData}
                openSnackbar={openSnackbar}
                {...signInDialog.props}
              />

            </>
          )}
        </Hidden>
      </>
    );
  }
}

DialogHost.propTypes = {
  // Properties
  performingAction: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object,
  userData: PropTypes.object,
  dialogs: PropTypes.object.isRequired,

  // Functions
  openSnackbar: PropTypes.func.isRequired,
};

export default DialogHost;
